export default {
      id: "i-service-analytics-min-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-analytics-min",
      toString: function () {
        return this.url;
      }
    }